import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'presentaties',
    templateUrl: 'presentaties.html'
})
export class Presentaties implements OnInit {
    constructor() { }

    ngOnInit() { }
}


// WEBPACK FOOTER //
// ./src/pages/presentaties/presentaties.ts